import {
	MediaCommands,
	useMediaCommands,
} from 'features/media-streaming/use-media-commands'
import useAudioStreamingApi from './audio-streaming-api'

/** The recording's commands, for its player and the console's remote alike. */
export const useAudioCommands = (): MediaCommands =>
	useMediaCommands(useAudioStreamingApi())

export default useAudioCommands
